import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CompaniesService } from '@services/companies.service';

@Injectable({
  providedIn: 'root',
})
export class ExistCompanyGuard implements CanActivate {
  constructor(private companiesService: CompaniesService, private router: Router) {}

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    return this.companiesService.getCompanyAsync().pipe(
      map((company) => {
        if (!company) {
          this.router.navigate(['/companies', 'account-settings', 'create']);
        }
        return !!company;
      }),
    );
  }
}
